import { regexRefine, minRefine } from 'validations/zod-helpers';
import { input, output, ZodEffects, ZodEffectsDef, ZodString, ZodType, ZodTypeAny } from 'zod';

declare module 'zod' {
  interface ZodString {
    minRefine(min: number): ZodEffects<ZodString, string, string>;
    regexRefine(
      regex: RegExp,
      options?: { message: string }
    ): ZodEffects<ZodString, string, string>;
  }
}

ZodString.prototype.minRefine = minRefine;
ZodString.prototype.regexRefine = regexRefine;

declare module 'zod' {
  interface ZodEffects<T extends ZodTypeAny, Output = output<T>, Input = input<T>>
    extends ZodType<Output, ZodEffectsDef<T>, Input> {
    options?: { message: string };
    minRefine(min: number): ZodEffects<ZodString, string, string>;
    regexRefine(
      regex: RegExp,
      options?: { message: string }
    ): ZodEffects<ZodString, string, string>;
  }
}

ZodEffects.prototype.minRefine = minRefine;
ZodEffects.prototype.regexRefine = regexRefine;
